"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringToCurrency = void 0;
const enums_1 = require("../enums");
const exceptions_1 = require("../exceptions");
const stringToCurrency = (currencyString) => {
    currencyString = currencyString.toUpperCase();
    const currency = enums_1.Currency[currencyString];
    if (typeof currency == 'undefined') {
        throw new exceptions_1.UnacceptableValueException(`Do not recognise currency '${currencyString}'`, {
            context: {
                providedValue: currencyString,
                validValues: JSON.stringify(Object.values(enums_1.Currency)),
            }
        });
    }
    return currency;
};
exports.stringToCurrency = stringToCurrency;
